import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeleteUserResponse, GetTeachersByFilterResponse, SearchTeachersResponse } from '@edtech-ui/core/models/admin-panel/admin-panel-models';
import { GetDepartmentsResponse, GetDesignationsResponse, InviteTeacherRequest, InviteTeacherResponse } from '@edtech-ui/core/models/admin-panel/invite-teacher.model';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TeacherManagementService {

  constructor(private http: HttpClient) { }
  apiUrl = environment.adminDashboardUrl;
  baseUrl = environment.batchApiUrl;

  inviteTeacher(payload: InviteTeacherRequest): Observable<InviteTeacherResponse> {
    return this.http.post<InviteTeacherResponse>(
      `${this.apiUrl}${environment.adminDashboardEndpoints.inviteTeacher}`,
      payload
    );
  }
  getDesignations(): Observable<GetDesignationsResponse> {
    return this.http.get<GetDesignationsResponse>(
      `${this.apiUrl}${environment.adminDashboardEndpoints.getDesignations}`
    );
  }
  getDepartments(): Observable<GetDepartmentsResponse> {
    return this.http.get<GetDepartmentsResponse>(
      `${this.baseUrl}/departments`
    );
  }
  getTeachersByFilter(
  filterType: 'active' | 'pending_invites' | 'by_department',
  departmentId?: number | string,
  page: number = 1,
  limit: number = 10,
  search?: string

): Observable<GetTeachersByFilterResponse> {

  let url = `${this.apiUrl}${environment.adminDashboardEndpoints.getTeachersByFilter}?filter_type=${filterType}`;

  if (departmentId && departmentId !== 'All Departments') {
    url += `&department_id=${departmentId}`;
  }
  if (search && search.trim() !== '') {
  url += `&search=${encodeURIComponent(search)}`;
}


  if (filterType !== 'by_department') {
    url += `&page=${page}&limit=${limit}`;
  }

  return this.http.get<GetTeachersByFilterResponse>(url);
}

  deleteActiveUser(userId: string): Observable<DeleteUserResponse> {
    const url = `${this.apiUrl}${environment.adminDashboardEndpoints.deleteUser}/${userId}`;
    return this.http.delete<DeleteUserResponse>(url);
  }

  deletePendingInvite(inviteId: string): Observable<DeleteUserResponse> {
    const url = `${this.apiUrl}${environment.adminDashboardEndpoints.deleteInvite}/${inviteId}`;
    return this.http.delete<DeleteUserResponse>(url);
  }

  searchTeachers(query: string): Observable<SearchTeachersResponse> {
    const url = `${this.apiUrl}${environment.adminDashboardEndpoints.searchTeachers}?query=${encodeURIComponent(query)}`;
    return this.http.get<SearchTeachersResponse>(url);
  }
}